<template lang="pug">
section.page_content_container
  .container
    .row.my-4.d-none.d-sm-block
      .col-lg-12
        .ck-content(
          v-for="activityContent in activityContentList",
          :key="activityContent.id", 
          v-html="activityContent.web_content"
        )
    .row.my-4.d-sm-none
      .col-lg-12
        .ck-content(
          v-for="activityContent in activityContentList",
          :key="activityContent.id", 
          v-html="activityContent.mobile_content"
        )
    .row.my-4
      .col-lg-12.text-center
        h2.title 為何選擇TOP巔峰
        p.sub-title 針對5-8歲，9-12歲，13歲-16歲孩子提供最專業的籃球教學
        .border-hr
      .col-lg-12.mt-5
        .top-basketball-items.d-none.d-sm-block
          .top-basketball-item
            img(src="@/assets/img/home/img_basketball_1.png")
            .top-basketball-text
              .text 小班制教學
              .text 師生比 1:10
              .text 學習有保障
          .top-basketball-item
            img(src="@/assets/img/home/img_basketball_2.png")
            .top-basketball-text
              .text 專項化教學設計
              .text 針對不同程度同學
              .text 不同教材
              .text 因材施教
          .top-basketball-item
            img(src="@/assets/img/home/img_basketball_3.png")
            .top-basketball-text
              .text 品德教育
              .text 訓練為輔
              .text 育人為主
              .text 學習團隊精神
              .text 有禮貌

        swiper.swiper-container.top-basketball-items.d-sm-none(
          :options="swiperOption",
          ref="mySwiper"
        )
          swiper-slide.swiper-slide.top-basketball-item
            img(src="@/assets/img/home/img_basketball_1.png")
            .top-basketball-text
              .text 小班制教學
              .text 師生比 1:10
              .text 學習有保障
          swiper-slide.swiper-slide.top-basketball-item
            img(src="@/assets/img/home/img_basketball_2.png")
            .top-basketball-text
              .text 專項化教學設計
              .text 針對不同程度同學
              .text 不同教材
              .text 因材施教
          swiper-slide.swiper-slide.top-basketball-item
            img(src="@/assets/img/home/img_basketball_3.png")
            .top-basketball-text
              .text 品德教育
              .text 訓練為輔
              .text 育人為主
              .text 學習團隊精神
              .text 有禮貌
          .swiper-pagination.swiper-pagination-white(slot="pagination")
        img.swiper-prev.d-sm-none(
          src="@/assets/img/icons/angle-left-solid-g.svg",
          @click="prevClick"
        )
        img.swiper-next.d-sm-none(
          src="@/assets/img/icons/angle-right-solid-g.svg",
          @click="nextClick"
        )

      .col-lg-12.mt-3.top-desc
        .text-center TOP巔峰籃球有著最完整的課程規劃，
        .text-center 讓孩子全面瞭解關於籃球運動的技術、規則、戰術，更同時鍛鍊孩子的團隊觀念，
        .text-center TOP巔峰致力於讓每個孩子都能夠喜歡籃球、熱愛籃球。
      .col-lg-12.text-center
        .sns-links
          .sns-link
            a(
              href="https://www.facebook.com/topbasketballcamp",
              target="_blank"
            )
              font-awesome-icon(:icon="['fab', 'facebook-square']")
          .sns-link
            a(href="https://line.me/R/ti/p/%40topbasketball", target="_blank")
              font-awesome-icon(:icon="['fab', 'line']")
          .sns-link
            a(
              href="https://www.instagram.com/topbasketballcamp/",
              target="_blank"
            )
              font-awesome-icon(:icon="['fab', 'instagram']") 
</template>

<script>
import { getActivityContentList } from "@/api/web_content";

export default {
  name: "PageContent",
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 1,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        },
        direction: "horizontal",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      sliderImageList: [],
      activityContentList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    this.getActivityContents();
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    getActivityContents() {
      getActivityContentList().then((response) => {
        this.activityContentList = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/home/page_content";
</style>
